export const API_PROJECT_PUBLICATIONS_RELATION_FIELDS = [
    'publications.project_publications_id'
];
